import { useAdobeUserUuidMessage } from "../features/adobe-user-uuid";
import { useCheckNewAssetsInfo } from "../features/check-new-assets-info";
import { useListenDevModeMessage } from "../features/dev-mode";
import { useDocumentChangedEvent } from "../features/document-event";
import { useListenNotifyMessage } from "../features/notify";
import { useListenOpenDialogMessage } from "../features/open-dialog";
import { useListenOpenExternalMessage } from "../features/open-external";
import { useListenOpenPsdMessage } from "../features/open-psd";
import { useListenReloadMessage } from "../features/reload";
import { useSelectionEvent } from "../features/selection-event";
import { useListenTestMessage } from "../features/test";

export function useFeatureListeners() {
	useListenOpenExternalMessage();
	useListenNotifyMessage();
	useListenTestMessage();
	useCheckNewAssetsInfo();
	useListenOpenPsdMessage();
	useListenOpenDialogMessage();
	useListenDevModeMessage();
	useListenReloadMessage();
	useAdobeUserUuidMessage();
	useSelectionEvent();
	useDocumentChangedEvent();
}
